<template>
	<Badge class="nobr" :status="statusDisplay" :text="text" />
</template>

<script>
import { computed, toRef } from 'vue';
import { Badge } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';


const STATUSES = {
	'updating': 'processing',
	'invalid': 'error',
	'verification': 'processing',
	'stopped': 'default',
	'deleted': 'default',
	'working': 'success',
}

export default {
	components: {
		Badge,
	},
	props: ['status'],
	setup(props) {
		const { t } = useI18n();
		const statusRef = toRef(props, 'status');
		const statusDisplay = computed(() => STATUSES[statusRef.value]);
		const text = computed(() => t('roverStatuses.' + statusRef.value));
		return {
			statusDisplay,
			text,
		}
	},
}
</script>
